export default class TabsAccessibility {
    constructor(NodeList) {
        this.tabList = NodeList;
        this.tabArray = Array.from(this.tabList.querySelectorAll('[role=tab]'));
        this.firstTab = this.tabArray[0];
        this.lastTab = this.tabArray[this.tabArray.length - 1];

        for (let i = 0; i < this.tabArray.length; i += 1) {
            let tab = this.tabArray[i];
            tab.addEventListener("keydown",  this.onKeydownFunction.bind(this))
            tab.addEventListener('click', this.onClick.bind(this));
        }
    }

    selectTab(selectedTab) {
        this.tabArray.forEach((tab) => {
            if (selectedTab === tab) {
                tab.tabIndex = 0;
                tab.focus();
                $(tab).tab('show');
            } else {
                tab.tabIndex = -1;
            }
        });

        return true
    }

    selectPrev(currentTab) {
        let index;

        if (currentTab === this.firstTab) {
            this.selectTab(this.lastTab);
        } else {
            index = this.tabArray.indexOf(currentTab);
            this.selectTab(this.tabArray[index - 1]);
        }
        return true
    }

    selectNext(currentTab) {
        let index

        if (currentTab === this.lastTab) {
            this.selectTab(this.firstTab);
        } else {
            index = this.tabArray.indexOf(currentTab);
            this.selectTab(this.tabArray[index + 1]);
        }
        return true
    }

    /* Define Event Listener */
    onKeydownFunction(event) {
        let target = event.currentTarget,
            flagged = false;

        switch (event.key) {
            case 'ArrowLeft':
                flagged = this.selectPrev(target);
                break;

            case 'ArrowRight':
                flagged = this.selectNext(target);
                break;

            case 'Home':
                flagged = this.selectTab(this.firstTab);
                break;

            case 'End':
                flagged = this.selectTab(this.lastTab);
                break;

            default:
                break;
        }

        if (flagged) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onClick(event) {
        this.selectTab(event.currentTarget);
    }
}